import { showGlobalLoader, hideGlobalLoader } from "@/utils/globalLoader";

/**
 * Syncs component `loading` / `isLoading` to GlobalPreloader.
 * Add to page-level components only (not skeletons / inline section loaders).
 *
 * Optional: `loadingMessage` in data, or static `loadingMessage: '…'` on export.
 */
export default {
  watch: {
    loading(isLoading) {
      this._syncGlobalLoader(isLoading);
    },
    isLoading(isLoading) {
      this._syncGlobalLoader(isLoading);
    },
  },

  mounted() {
    if (this.loading || this.isLoading) {
      this._syncGlobalLoader(true);
    }
  },

  beforeUnmount() {
    if (this.loading || this.isLoading) {
      hideGlobalLoader();
    }
  },

  methods: {
    _syncGlobalLoader(isLoading) {
      if (isLoading) {
        const msg =
          this.loadingMessage ||
          this.loaderMessage ||
          (typeof this.$options.loadingMessage === "string"
            ? this.$options.loadingMessage
            : "");
        showGlobalLoader(msg);
      } else {
        hideGlobalLoader();
      }
    },
  },
};
